const HomeReducer = (state = {}) => {
    return state;
};

export default HomeReducer;
